export const FORM_STUDIO_DEFAULT_SECTION = 'overview';

export const FORM_STUDIO_SECTIONS = Object.freeze([
  {
    value: 'overview',
    label: 'Overview',
    title: 'Form overview',
    description: 'Review the form setup, purpose, and publishing status.',
    icon: 'overview',
  },
  {
    value: 'fields',
    label: 'Fields',
    title: 'Form fields',
    description: 'Field configuration and layout tools will be added here.',
    icon: 'fields',
  },
  {
    value: 'automations',
    label: 'Automations',
    title: 'Automations',
    description: 'Connect triggers and follow-up actions to this form.',
    icon: 'automations',
  },
  {
    value: 'assets',
    label: 'Assets',
    title: 'Assets',
    description: 'Manage files and supporting content used by the form.',
    icon: 'assets',
  },
]);

export const FORM_STUDIO_COPY = Object.freeze({
  create: {
    eyebrow: 'Business Functions Form Studio',
    title: 'Create a form',
    subtitle: 'Set up a new form for this business service.',
  },
  edit: {
    eyebrow: 'Business Functions Form Studio',
    title: 'Edit form',
    subtitle: 'Manage this form and its business process configuration.',
  },
  back: 'Back to business service',
  foundationBadge: 'Studio foundation',
  placeholder: 'Configuration tools for this section are coming next.',
  navigationLabel: 'Form studio sections',
  dirty: 'Unsaved changes',
  createForm: 'Create form',
  save: 'Save changes',
  saving: 'Saving…',
  deleteForm: 'Delete form',
  deleting: 'Deleting…',
  deleteSuccess: 'Form deleted',
  deleteError: 'Unable to delete this form.',
  deleteTitle: 'Delete this form?',
  deleteMessage: 'This removes the form. A form can only be deleted when it has no records.',
  deleteConfirm: 'Delete form',
  deleteCancel: 'Keep form',
  sectionLocked: 'Save the form first to open this section.',
  createSuccess: {
    title: 'Form created',
    description: 'Your form shell is ready. Add fields next so you can start collecting records.',
    addFields: 'Add fields',
    stayHere: 'Stay on overview',
  },
  setupProgress: {
    label: 'Setup progress',
    overview: 'Overview',
    fields: 'Fields',
    automations: 'Automations',
  },
  statusField: {
    optionsTitle: 'Status options',
    optionsCaption: 'These values appear in records for this status field.',
    noStatusOptions: 'No status options configured yet.',
    keyNameRequired: 'Set field key name before adding options.',
    parentFieldLabel: 'Parent status field',
    selectParentStatus: 'Select a status field',
    noParentStatusFields: 'Create a Status field before configuring this Sub-status field.',
    noParentStatusOptions: 'Add options to the selected Status field before configuring sub-statuses.',
    perOptionTitle: 'Sub-status options per status value',
    perOptionCaption:
      'Set different sub-status options for each value in the selected Status field.',
    perOptionEmpty: 'No sub-status options yet.',
    perOptionEditTooltip: 'Edit sub-status options',
  },
  automations: {
    saveFirst: 'Save the form first to configure automations.',
    statusTriggers: {
      title: 'Status triggers',
      caption: 'Actions that run immediately when a record’s status or sub-status changes.',
      parentFieldLabel: 'Parent status field',
      statusTriggersTitle: 'Status triggers',
      subStatusTriggersTitle: 'Sub-status triggers',
      statusLevelLabel: 'Status trigger',
      addTrigger: 'Add trigger',
      editTrigger: 'Edit trigger',
      noTriggers: 'No triggers configured yet.',
      noStatusField: 'Add a Status field in Fields before configuring triggers.',
      noStatusOptions: 'Add status options on the selected Status field first.',
      goToFields: 'Go to Fields',
      loading: 'Loading triggers…',
      syncHint: 'Save the form to sync status options, then configure triggers here.',
      validationHint: 'Complete the required trigger fields before applying.',
    },
    scheduled: {
      title: 'Scheduled automations',
      caption: 'Run actions after a delay or on a recurring schedule.',
      addAutomation: 'Add automation',
      createTitle: 'Create automation',
      editTitle: 'Edit automation',
      saveLabel: 'Save automation',
      actionLabel: 'Action',
      whenSection: 'When status is',
      afterSection: 'After',
      thenSection: 'Then move to',
      typeOfStatusFilter: 'Type of status',
      currentStatus: 'Current status',
      nextStatus: 'Next status',
      delayValue: 'Delay value',
      delayUnit: 'Delay unit',
      description: 'Description',
      frequency: 'Frequency',
      sendTime: 'Send time',
      template: 'Template',
      botNumber: 'Bot number',
      activeLabel: 'Active',
      active: 'Active',
      inactive: 'Inactive',
      updateStatusLabel: 'Update status',
      leadSummaryLabel: 'Lead summary',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      deleteTitle: 'Delete automation?',
      deleteMessage: 'This scheduled automation will be removed.',
      loading: 'Loading automations…',
      saveSuccess: 'Automation saved',
      saveError: 'Failed to save automation',
      deleteSuccess: 'Automation deleted',
      deleteError: 'Failed to delete automation',
    },
  },
  readiness: {
    coreCompleteTitle: 'Core setup complete',
    coreCompleteDescription:
      'Your form can collect records. Configure the optional steps below when you are ready.',
    allCompleteTitle: 'Form looks ready',
    configureStatusOptions: 'Add status options on your Status field.',
    configureAutomations: 'Add automations (optional).',
    statusNotRequired: 'No status field on this form.',
  },
  reload: 'Retry',
  loadError: 'Unable to load this form.',
  saveError: 'Unable to save this form.',
  permissionDenied:
    'You do not have edit access to this business service. Ask an admin to grant Edit on this workspace (or its business function) in Profile Management.',
});
